import React from 'react'

const Laminar = () => {
  return (
    <div>
      <section class="inner-banner">
        <div class="thm-container">
          <h2> Product Details </h2>
          <div class="breadcumb">
            <a href="/">Chambers</a>
            <i class="fa fa-angle-right"></i>
            <span>Laminar Air Flow</span>
          </div>
        </div>
      </section>
      <div className='container py-4'>
        <div className='row d-flex' style={{ margin: "80px 0px" }}>
          <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <img src='/img/laminar.png' width={400}></img>
          </div>
          <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <h2 style={{ textDecoration: "underline" }}>Laminar Air Flow:</h2>
            <h4 style={{ textDecoration: "underline" }}>WLS- 22LAF, WLS- 32LAF, WLS- 42LAF, WLS- 62LAF, WLS- 82LAF</h4>
            <p className="mbot25">
              A laminar air flow workstation is a closed cabinet fitted with HEPA filtered air flow system with unidirectional
              constant flow of air with almost no or minimal turbulence. The air flow velocity
              remains between 0.4 m/s to 0.6 m/s. The purpose of using such workstations in laboratory is to
              create particle and bacteria free working environment to carry out specialized work.
              As this unit’s discharge air towards user, they provide no personal protection but product protection from room contaminants.
            </p>
            <h3 style={{ textDecoration: "underline" }}>Types:</h3>
            <h4 style={{ textDecoration: "underline" }}>Vertical Laminar Air Flow:</h4>
            <p className='mbot25'>
              It is the most used type of laminar air flow. In vertical flow cabinet, room air
              is entered in working area through HEPA filter fitted on top of the cabinet. Thus, air flows downward (vertically)
              towards work surface and leaves the cabinet sweeping out particles and bacteria.
            </p>
            <h4 style={{ textDecoration: "underline" }}>Horizontal Laminar Air Flow:</h4>
            <p className='mbot25'>
              In horizontal air flow cabinet, room air is entered in working area through HEPA filter fitted on the back side of the cabinet.
              Filtered air flows horizontally towards the user creating sterile working environment.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Laminar
